import { PHOTON_URL } from './providers'

export interface Place {
  name: string
  detail: string
  lng: number
  lat: number
  kind: string
}

interface PhotonFeature {
  geometry: { coordinates: [number, number] }
  properties: {
    name?: string
    street?: string
    housenumber?: string
    city?: string
    state?: string
    country?: string
    osm_value?: string
    osm_key?: string
  }
}

function toPlace(f: PhotonFeature): Place {
  const p = f.properties
  const name = p.name ?? [p.street, p.housenumber].filter(Boolean).join(' ') ?? 'Unknown'
  const detail = [p.city, p.state, p.country].filter((x) => x && x !== name).join(', ')
  return {
    name,
    detail,
    lng: f.geometry.coordinates[0],
    lat: f.geometry.coordinates[1],
    kind: p.osm_value ?? p.osm_key ?? 'place',
  }
}

export async function searchPlaces(query: string, near?: [number, number], signal?: AbortSignal): Promise<Place[]> {
  const url = new URL(`${PHOTON_URL}/api/`)
  url.searchParams.set('q', query)
  url.searchParams.set('limit', '6')
  if (near) {
    url.searchParams.set('lon', near[0].toFixed(4))
    url.searchParams.set('lat', near[1].toFixed(4))
  }
  const res = await fetch(url, { signal })
  if (!res.ok) return []
  const data = (await res.json()) as { features?: PhotonFeature[] }
  return (data.features ?? []).map(toPlace)
}

export async function reverseGeocode(lng: number, lat: number, signal?: AbortSignal): Promise<Place | null> {
  const url = new URL(`${PHOTON_URL}/reverse`)
  url.searchParams.set('lon', String(lng))
  url.searchParams.set('lat', String(lat))
  const res = await fetch(url, { signal })
  if (!res.ok) return null
  const data = (await res.json()) as { features?: PhotonFeature[] }
  return data.features?.length ? toPlace(data.features[0]) : null
}
